// extracted by mini-css-extract-plugin
module.exports = {"log_text":"ExamLog_log_text__2ymcR"};